import { isFiniteNumber } from 'partner360/lib/metricFormatting'

import {
  PARTNERS_COVERAGE_PERCENT_ROW_LABELS,
  PARTNERS_COVERAGE_TOTAL_PARTNERS_ROW_LABEL,
  TPartnersCoverageColumnKey,
} from '../configs/coverageTables'
import { IPartnersCoverageRow } from '../model/types'

/** Deck locale, the report keeps `1,731` and `92.8%` regardless of the user locale. */
const COVERAGE_LOCALE = 'en-US'

const EMPTY_CELL = ''
const NOT_APPLICABLE_CELL = '-'

const formatNumber = (value: number, fractionDigits: number) =>
  new Intl.NumberFormat(COVERAGE_LOCALE, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)

const isPercentRow = (rowLabel: string) =>
  PARTNERS_COVERAGE_PERCENT_ROW_LABELS.some((label) => label === rowLabel)

/**
 * Renders one coverage cell the way the Partners Coverage deck does:
 *  - `partnersPbm` is a ratio of the whole table and is printed in its first metric row only
 *  - `% of partners with plan` and `Amplify Coverage` are percentages with one decimal
 *  - other metric rows are integer counts
 *  - missing values stay empty
 */
export const formatCoverageValue = (
  row: IPartnersCoverageRow,
  columnKey: TPartnersCoverageColumnKey
): string => {
  const value = row[columnKey]

  if (columnKey === 'partnersPbm') {
    if (row.rowLabel !== PARTNERS_COVERAGE_TOTAL_PARTNERS_ROW_LABEL || !isFiniteNumber(value)) {
      return NOT_APPLICABLE_CELL
    }

    return formatNumber(value, Number.isInteger(value) ? 0 : 1)
  }

  if (!isFiniteNumber(value)) {
    return EMPTY_CELL
  }

  if (isPercentRow(row.rowLabel)) {
    return `${formatNumber(value, 1)}%`
  }

  return formatNumber(value, 0)
}
